const MAX_PACKAGE_SIZE = 2000; // 20 meters
const MAX_PACKAGE_WEIGHT = Math.pow(2, 31) - 1;

export { MAX_PACKAGE_SIZE, MAX_PACKAGE_WEIGHT };
